import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "./apiUrl";

export const useAllDays = () => {
  const [item, setItem] = useState([]);

  
  useEffect(() => {
    const fetchResult = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/getAllDays.php`);

        setItem(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchResult();
  }, []);

  return item;
};
